export class ElasticSearchFilterValue {
  field: string;
  value: string;
  keyword: boolean;

  constructor(field: string = '', value: string = '', keyword: boolean = false) {
    this.field = field;
    this.value = value;
    this.keyword = keyword;
  }
}
